const getters = {
  kycDocuments (state) {
    const documents = state.core.userProfile.entity.documents

    if (!documents) return []

    return documents.filter(document => document.tag === 'kyc')
  }
}

export default getters
